export function waitingFor(iso: string, now: Date = new Date()): string {
  const minutes = Math.max(0, (now.getTime() - new Date(iso).getTime()) / 60_000);
  if (minutes < 60) return `${String(Math.max(1, Math.round(minutes)))} min`;
  if (minutes < 1440) return `${String(Math.round(minutes / 60))} h`;
  const days = Math.floor(minutes / 1440);
  return days === 1 ? "1 day" : `${String(days)} days`;
}
